import React, { useContext, useEffect, useState } from 'react';
import PageWithTitleLayout from '../Layout/PageWithTitleLayout';
import { 
    Tab,
    Box,
    Alert
} from '@mui/material'
import {
    TabContext,
    TabList,
} from '@mui/lab'
import UserManagementList from './UserManagementList';
import UserManagementEdit from './UserManagementEdit'
import UserManagementStores from './UserManagementStores';
import EditStore from './EditStore';
import { useStickyString } from '../../Utilities/useStickyState';
import { PATHS } from '../../constants';
import { Route, Switch } from 'react-router-dom';
import { EmploymentsContext } from '../../contexts/EmploymentsContext';
import { SELECTED_STORE_CHANGED_EVENT } from '../../Utilities/authenticationService';

const ManagerSettings = ({ history }) => {
    const [tabValue, setTabValue] = useStickyString('users', 'frederickManagerSettingsTabValue')
    const [selectedEmploymentId, setSelectedEmploymentId] = useState(
        () => parseInt(localStorage.getItem('selected_emp') || 0, 10)
    )
    const { isManagerFor, isAdmin } = useContext(EmploymentsContext)
    const hasStoreAccess = isAdmin || isManagerFor?.[selectedEmploymentId]

    useEffect(() => {
        if(history.location.pathname.includes('stores')) {
            setTabValue('stores')
        } else {
            setTabValue('users')
        }
    }, [history.location.pathname, setTabValue])

    useEffect(() => {
        const handleStoreChanged = e => {
            const newId = parseInt(e.detail?.employmentId ?? (localStorage.getItem('selected_emp') || 0), 10)
            setSelectedEmploymentId(newId)
        }
        window.addEventListener(SELECTED_STORE_CHANGED_EVENT, handleStoreChanged)
        return () => window.removeEventListener(SELECTED_STORE_CHANGED_EVENT, handleStoreChanged)
    }, [])
    
    return (
        <PageWithTitleLayout title='ユーザー・店舗情報'>
            {!hasStoreAccess && selectedEmploymentId ? (
                <Alert severity="warning" sx={{ mx: '1rem', mt: '1rem' }}>
                    この店舗の編集にアクセス権限がありません。
                </Alert>
            ) : (
                <TabContext value={tabValue}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList 
                            onChange={(e, newValue) => { 
                                history.push(PATHS.managerSettings + newValue); setTabValue(newValue)}
                            }
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab label="ユーザー情報" value="users" />
                            <Tab label="店舗情報" value="stores" />
                        </TabList>
                    </Box>
                    <Switch>
                        <Route exact path={PATHS.managerSettingsUsers} component={UserManagementList} />
                        <Route exact path={PATHS.managerSettingsStores} component={UserManagementStores} />
                        <Route exact path={PATHS.managerSettingsUser} component={UserManagementEdit} />
                        <Route exact path={PATHS.managerSettingsStore} component={EditStore} />
                    </Switch>
                </TabContext>
            )}
        </PageWithTitleLayout>
    );
}

export default ManagerSettings;